<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div id="print" class="card-panel-main col-lg-9 mb-5  " style="transform: translateX(-19vw)">
      <div class="d-flex flex-nowrap no_print hide p-2">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between ">
              <h2 style="font-size: 1.2vw !important;">دسته‌ بندی فرآیند</h2>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
            </div>
            <form class="needs-validation" novalidate>
              <div class="row">
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label required">عنوان دسته</label>
                  <textarea class="form-control" v-model="nameCat" :style="{ height: nameCatHeight }" cols="30" rows="1"></textarea>
                </div>
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label ">عنوان انگلیسی</label>
                  <textarea class="form-control" v-model="title_en" :style="{ height: title_enHeight }" cols="30" rows="1"></textarea>
                </div>
                <div style="width: 9vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required">نحوه کدگذاری </label>
                  <select class="form-select" v-model="encodingMethodCat" required>
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option value="حرف اختصاری">حرف اختصاری</option>
                    <option value="عدد">عدد</option>
                    <option value="حرف اختصاری و عدد">حرف اختصاری و عدد</option>
                  </select>
                </div>
                <div style="width: 8vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required">حرف اختصاری</label>
                  <input :disabled="encodingMethodCat==='عدد'" :placeholder="encodingMethodCat==='عدد' ? 'ندارد' : ''"
                         class="form-control" v-model="shortNameCat">
                </div>
                <div style="width: 10vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required"> سطوح زیرمجموعه</label>
                      <input readonly @click="addNewSelectedSub"
                         :placeholder="subLevelsCat1 || subLevelsCat2 || subLevelsCat3 || subLevelsCat4 ? ((subLevelsCat1 ? 'طبقه' : '')+' '+(subLevelsCat2? 'گروه' : '')+' '+(subLevelsCat3? 'فرآیند' : '')+' '+(subLevelsCat4? 'زیرفرآیند' : '')):'انتخاب کنید'"
                         type="text" class="form-control" placeholder="انتخاب کنید">
                </div>
                <div class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required">سطح تعریف شناسنامه </label>
                  <input readonly @click="addNewIdCard" type="text" class="form-control"
                  :placeholder="subLevelsCat2_id||subLevelsCat3_id||subLevelsCat4_id ? ((subLevelsCat2_id ? 'گروه' :'')+' '+(subLevelsCat3_id ? 'فرآیند':'')+' '+(subLevelsCat4_id ? 'زیر فرآیند' : '')):''"
                  >
                </div>
                <div class="col-lg-2 mb-3 ms-n-08" style="margin-top: 1.5vw;">
                  <input class="form-check-input" type="checkbox" v-model="isValueChainCat">
                  <label style="margin-right: .5vw; margin-top: -.2vw; font-size: 1vw;" class="form-check-label">زنجیره
                    ارزش است</label>
                </div>
                <div style="margin-top: 1.5vw;" class="col-lg-1 mb-3 d-flex">
                  <button  class="btn btn-primary btn-submit-1" type="button" @click="addCategory">
                    <p v-if="!loader"
                      style="font-size: 1.8vw; transform: translateY(.80vw)">+</p>
                    <div v-else>
                      <div class="loader-line"></div>
                    </div>
                  </button>
                </div>
              </div>
            </form>
            <hr>
          </div>
        </div>
      </div>
      <div v-show="allProcesses.length" class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width: 9vw;">لیست فرآیند</h2>
            </div>
            <form class="needs-validation mt-2 mb-3" novalidate>
              <div class="row">
                <div style="transform: translateY(-1.5vw)" class="hide col-lg-12 mb-3 no_print">
                  <input v-model="searchProcesses" type="text" class="form-control" style="width: 20vw;"
                         placeholder="جستجو بر اساس عنوان و کد  ...">
                </div>
              </div>
              <hr style="transform: translateY(-1.9vw)">
            </form>
            <div style="transform: translateY(-1.5vw)" class="table-responsive">
              <table v-show="allProcesses.length" class="table table-striped">
                <thead>
                <tr>
                  <th>ردیف</th>
                  <th>عنوان</th>
                  <th>معادل انگلیسی عنوان</th>
                  <th>سطح فرآیند</th>
                  <th>کد</th>
                  <th class="no_print hide" style="width: 14vw;">عملیات‌ها</th>
                </tr>
                </thead>
                <!-- در بخش tbody -->
                <tbody id="sortable-table-body">
                <tr
                  v-for="(item,index) in filteredItems"
                  :key="item.id"
                  :style="setcolor(item['level'])"
                  :data-id="item.id"
                  :class="{ 'not-draggable': item['type'] != 3 }"
                >
                  <td scope="row">{{ index + 1 }}</td>
                  <td style="text-align: right">{{ item['title'] }}</td>
                  <td v-if="item['title_en']"> {{ item['title_en'] }}</td>
                  <td v-else>--</td>
                  <td v-if="item['type']">
                    <span v-if="item['type']==1">طبقه</span>
                    <span v-else-if="item['type']==2">گروه</span>
                    <span v-else-if="item['type']==3">فرآیند</span>
                    <span v-else-if="item['type']==4">زیرفرآیند</span>
                  </td>
                  <td v-else>دسته</td>
                  <td>{{ item['code'] }}</td>
                  <td class="no_print hide">
                    <div class="d-flex justify-content-start align-items-center">
                      <!-- آیکون دست برای جابجایی (فقط برای فرآیندها) -->
                      <span v-if="item['type'] == 3" class="drag-handle" title="جابجایی">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="9" cy="12" r="1"></circle>
                          <circle cx="9" cy="5" r="1"></circle>
                          <circle cx="9" cy="19" r="1"></circle>
                          <circle cx="15" cy="12" r="1"></circle>
                          <circle cx="15" cy="5" r="1"></circle>
                          <circle cx="15" cy="19" r="1"></circle>
                        </svg>
                      </span>
                      <router-link  v-show="showIdCard(item['idcard_group'] , item['idcard_process'],item['idcard_sub_process'],item['type'])"
                                    :to="`/process/id/complete/${item['id']}`"><img style="margin-right: .5vw;" class="table-edit-img" src="/img/id.02f9043a.svg"
                                                                                   alt="prev">  </router-link>
                      <a @click.prevent="editMethod(item['id'])" href="#"><img style="margin-right: .5vw;"
                                                                               class="table-edit-img"
                                                                               src="../../assets/img/pen.svg"
                                                                               alt="edit"></a>
                      <a @click.prevent="deleteItemModal(item['id'])" href="#"><img style="margin-right: .5vw;"
                                                                                     class="table-delete-img"
                                                                                     src="../../assets/img/delete.svg"
                                                                                     alt="delete"></a>
                      <a
                          v-if="resultShow(parseInt(item.type),item.is_floor,item.is_group,item.is_process,item.is_sub_process)"
                          href="#"
                         @click.prevent="parseInt(item['type'])!==4 ? addParentProcessesMethod(item['id'], item['type']) : ''"
                         style="display:inline-block; transform: translateY(.1vw); width: 1.5vw; height: 1.5vw;margin-right: .5vw; text-decoration: none; font-size: 1.1vw; background-color: green; border-radius: 50%;  color: white;text-align: center;">+</a>
                      <p v-else>
                        <span style="width: 1.9vw; display:block;"></span>
                      </p>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- نقشه فرآیندی جدید -->
      <div class="row" v-show="allProcesses.length">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="padding: 0; overflow: hidden; display: flex; flex-direction: column;">
            <!-- هدر و کنترل‌ها -->
            <div class="d-flex justify-content-between align-items-center p-3 map-header"
                 style="background: #3742FA; color: white; cursor: pointer;"
                 @click="toggleMap">
              <div class="d-flex align-items-center">
                <span class="accordion-icon me-2" :style="{ transform: isMapCollapsed ? 'rotate(0deg)' : 'rotate(-90deg)' }">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </span>
                <h2 style="font-size: 0.9vw !important;  margin: 0;color: white;">نقشه فرآیندی</h2>
              </div>
              <div class="d-flex align-items-center gap-2">
                <div class="zoom-controls d-flex align-items-center" style="gap: 10px;">
                  <button @click.stop="zoomIn" :disabled="isMapCollapsed" class="btn-zoom-custom" title="بزرگنمایی">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  </button>
                  <button @click.stop="zoomOut" :disabled="isMapCollapsed || scale <= minScale" class="btn-zoom-custom" title="کوچکنمایی">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  </button>
                  <span v-show="!isMapCollapsed" style="font-size: 12px; margin-left: 2px;">{{ Math.round(scale * 100) }}%</span>
                </div>
                <div class="action-controls d-flex align-items-center" style="gap: 10px;">
                  <button @click.stop="resetView" :disabled="isMapCollapsed || scale <= minScale"  class="btn-action-custom" title="بازگشت به حالت اولیه">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                      <path d="M3 3v5h5"></path>
                    </svg>
                  </button>
                  <button @click.stop="downloadMap" :disabled="isMapCollapsed" class="btn-action-custom" title="دانلود نقشه">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <!-- ویوپورت نقشه -->
            <div
              v-show="!isMapCollapsed"
              class="map-viewport"
              @mousedown="startDrag"
              @mousemove="onDrag"
              @mouseup="stopDrag"
              @mouseleave="stopDrag"
              ref="viewportRef"
            >
           <div
  v-if="mapCategories.length > 0"
  ref="canvasRef"
  class="map-canvas"
  :style="{
    height: `${contentHeight}px`,
    transform: `translate(${translateX}px, ${translateY}px) scale(${scale})`,
    cursor: isDragging ? 'grabbing' : 'grab'
  }"
>
                <!-- فلش‌های کناری با SVG -->
                <div class="side-arrow right">
                  <svg width="100%" height="100%" viewBox="0 0 60 800" preserveAspectRatio="none" style="position: absolute; top: 0; left: 0;">
                    <path d="M20 0 L60 0 L60 800 L20 800 L0 400 Z" fill="#2d3478" />
                  </svg>
                  <span class="arrow-text" style="margin-left: 10px;">ورودی ها : مواد اولیه ، نیازها و انتظارات ذینفعان ، الزامات و قوانین</span>
                </div>
                <div class="side-arrow left">
                  <svg width="100%" height="100%" viewBox="0 0 60 800" preserveAspectRatio="none" style="position: absolute; top: 0; left: 0;">
                    <path d="M0 0 L40 0 L60 400 L40 800 L0 800 Z" fill="#2d3478" />
                  </svg>
                  <span class="arrow-text" style="margin-right: 3px;">خروجی : محصولات ، خدمات و رضایت ذینفعان</span>
                </div>
                <!-- محتوای دسته‌ها -->
                <div class="categories-wrapper">
                  <div v-for="cat in mapCategories" :key="cat.id" class="category-box">
                    <div class="cat-header">
                      <div class="cat-title-en">{{ cat.titleEn }}</div>
                      <div class="cat-title-fa">{{ cat.titleFa }}</div>
                    </div>
                    <div class="cat-content">
                      <div v-for="cls in cat.classes" :key="cls.id" class="class-box">
                        <div class="class-title">{{ cls.title }}</div>
                        <div v-for="group in cls.groups" :key="group.id" class="group-box">
                          <div class="group-title">{{ group.title }}</div>
                          <div
                            v-for="proc in group.processes"
                            :key="proc.id"
                            class="process-box"
                            :style="{ backgroundColor: proc.color || '#ffd6db' }"
                          >
                            {{ proc.title }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-data-message">
                <p>اطلاعاتی یافت نشد</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- پایان نقشه فرآیندی جدید -->
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="openModalsubLevelsCat" style="z-index: 999999999999999">
    <div>
      <p>انتخاب سطوح زیرمجموعه</p>
      <p @click="openModalsubLevelsCat=!openModalsubLevelsCat">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; width: 25vw; padding: 1vw; border-radius: 1vw">
        <p class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat1" type="checkbox" value="طبقه">
            طبقه
          </label>
        </p>
        <p class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat2" type="checkbox" value="گروه">
            گروه
          </label>
        </p>
        <p class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat3" type="checkbox" value="فرآیند">
            فرآیند
          </label>
        </p>
        <p class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat4" type="checkbox" value="زیر فرآیند">
            زیر فرآیند
          </label>
        </p>
      </div>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="openModalsubLevelsCat=!openModalsubLevelsCat" class="btn btn-primary btn-back" type="submit">
          برگشت
        </button>
        <button class="btn btn-primary btn-approve" @click="removeModalSelectedSub">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="openModalsubLevelsCatForIdCard"
       style="z-index: 999999999999999">
    <div>
      <p>سطح تعریف شناسنامه</p>
      <p @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; width: 25vw; padding: 1vw; border-radius: 1vw">
        <p v-show="subLevelsCat2" class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat2_id" type="checkbox" value="گروه">
            گروه
          </label>
        </p>
        <p v-show="subLevelsCat3" class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat3_id" type="checkbox" value="فرآیند">
            فرآیند
          </label>
        </p>
        <p v-show="subLevelsCat4" class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat4_id" type="checkbox" value="زیر فرآیند">
            زیر فرآیند
          </label>
        </p>
      </div>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard" class="btn btn-primary btn-back"
                type="submit">
          برگشت
        </button>
        <button class="btn btn-primary btn-approve"
                @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard">تایید
        </button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="modalTitleFa" style="z-index: 999999999999999">
    <div>
      <p>ویرایش عنوان</p>
      <p @click="modalTitleFa=!modalTitleFa">❌</p>
    </div>
    <div>
      <div>
        <input v-model="title_for_edit_fa" placeholder="عنوان خود را وارد کنید" type="text" class="form-control"
               style="width: 20vw;">
      </div>
      <button @click="updateTitles(this.ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="modalTitleEn" style="z-index: 999999999999999">
    <div>
      <p>ویرایش عنوان انگلیسی</p>
      <p @click="modalTitleEn=!modalTitleEn">❌</p>
    </div>
    <div>
      <div>
        <input v-model="title_for_edit_en" placeholder="عنوان انگلیسی خود را وارد کنید" type="text" class="form-control"
               style="width: 20vw;">
      </div>
      <button @click="updateTitles(ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(ProcessesId)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="addParentProcesses" style="z-index: 999999999999999">
    <div>
      <p>افزودن زیرمجموعه {{ itemProcesses.category }}</p>
      <p @click="addParentProcesses=!addParentProcesses">❌</p>
    </div>
    <div v-if="((itemProcesses.is_floor && is_floor_select )|| (itemProcesses.is_group && is_group_select)|| (itemProcesses.is_process && is_process_select)|| (itemProcesses.is_sub_process || is_sub_process_select)) === false">
      <center class="bg-white p-3" style="border-radius: 1vw">
        سطح پایین تری در فرآیند  {{ itemProcesses.category }} وجود ندارد!
      </center>
    </div>
    <div v-else>
      <div>
        <div class="d-flex">
          <div>
            <label style="font-size: .88vw; text-align: right;width: 100%;" class="required">عنوان</label>
            <input v-model="title_for_edit_fa_processes" placeholder="عنوان خود را وارد کنید" style="width: 13vw;"
                   type="text" class="form-control">
          </div>
          <div style="font-size: .88vw; text-align: right">
            <label>عنوان انگلیسی</label>
            <input v-model="title_for_edit_en_processes" placeholder="عنوان انگلیسی را وارد کنید"
                   style="width: 13vw; margin-right: 1vw;" type="text" class="form-control">
          </div>
        </div>
        <br>
        <label class="required" style="font-size: .88vw; text-align: right;width: 100%;">سطح فرآیند </label>
        <select v-model="levelSub_processes" class="form-select">
          <option selected v-if="itemProcesses.is_floor && is_floor_select" value="1">طبقه</option>
          <option selected v-if="itemProcesses.is_group && is_group_select" value="2">گروه</option>
          <option selected v-if="itemProcesses.is_process && is_process_select" value="3">فرآیند</option>
          <option selected v-if="itemProcesses.is_sub_process && is_sub_process_select" value="4">زیر فرآیند</option>
        </select>
         <!-- چک باکس جدید: خدمت است -->
        <div v-if="is_process_select" class="d-flex align-items-center mt-3">
            <input class="form-check-input" type="checkbox" v-model="is_service" id="isServiceCheck" style="margin-left: 5px;">
            <label for="isServiceCheck" style="font-size: .88vw; margin-right: 5px; cursor: pointer;">خدمت است</label>
        </div>
      </div>
      <button @click="SubmitParent">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="editModal" style="z-index: 999999999999999">
    <div>
      <p>ویرایش</p>
      <p @click="editModal=!editModal">❌</p>
    </div>
    <div>
      <div>
        <div class="d-flex">
          <div>
            <label style="font-size: .88vw; text-align: right;width: 100%;">عنوان</label>
            <input v-model="title_for_edit_fa" placeholder="عنوان خود را وارد کنید" style="width: 13vw;" type="text"
                   class="form-control">
          </div>
          <div style="font-size: .88vw; text-align: right">
            <label>عنوان انگلیسی</label>
            <input v-model="title_for_edit_en" placeholder="عنوان انگلیسی را وارد کنید"
                   style="width: 13vw; margin-right: 1vw;" type="text" class="form-control">
          </div>
        </div>
        <br>
        <label v-if="levelSub" style="font-size: .88vw; text-align: right;width: 100%;">سطح فرآیند </label>
        <select v-if="levelSub" v-model="levelSub" class="form-select">
          <option value="" selected disabled>انتخاب کنید</option>
          <option v-if="itemProcesses.is_floor" value="1">طبقه</option>
          <option v-if="itemProcesses.is_group" value="2">گروه</option>
          <option v-if="itemProcesses.is_process" value="3">فرآیند</option>
          <option v-if="itemProcesses.is_sub_process" value="4">زیر فرآیند</option>
        </select>
      </div>
      <button @click="updateForm(ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="cloneAllModal" style="z-index: 999999999999999">
    <div>
      <p>اطلاعیه</p>
      <p @click="cloneAllModal=!cloneAllModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید موارد در تمامی شرکت های زیرمجموعه ایجاد شود؟</p>
      <button @click="submitCloneAll">تایید</button>
    </div>
  </div>
  <!-- modal  -->
</template>
<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
import html2canvas from 'html2canvas';
import Sortable from 'sortablejs';
const toast = useToast();
export default {
  name: "process_map",
  components: {Sidebar, Splash},
  data() {
    return {
      //*******************************
      //*******************************
      // todo: for categories *******************************
      // *******************************
      categories: [],
      nameCat: '',
      realMapHeight: 365,
      shortNameCat: '',
      encodingMethodCat: '',
      level_cardid: '',
      title_en: '',
      subLevelsCat1: '',
      subLevelsCat2: '',
      subLevelsCat3: '',
      subLevelsCat4: '',
      sub_id: 0,
      isValueChainCat: false,
      openModalsubLevelsCat: false,
      // todo: for categories *******************************
      //*******************************
      // *******************************
      Error: false,
      ErrorM: '',
      // *******************************
      // *******************************
      // todo: for Processes *******************************
      allProcesses: [],
      searchProcesses: '',
      ProcessesId: '',
      addParentProcesses: false,
      loader: false,
      modalTitleEn: false,
      modalTitleFa: false,
      editModal: false,
      deleteModal: false,
      showMore: false,
      title_for_edit: '',
      title_for_edit_fa: '',
      levelSub: '',
      title_for_edit_en: '',
      itemProcesses: [],
      table_all_Processes: [],
      table_all_Processes_floor: [],
      table_all_Processes_groups: [],
      table_all_Processes_process: [],
      table_all_Processes_sub_process: [],
      title_for_edit_fa_processes: '',
      title_for_edit_en_processes: '',
      levelSub_processes: '',
      is_service: false,
      //*******************************
      table_all_Processes_by_group: [],
      table_all_Processes_groups_by_group: [],
      table_all_Processes_process_by_group: [],
      table_all_Processes_sub_process_by_group: [],
      //*******************************
      table_all_Processes_by_processes: [],
      table_all_Processes_process_by_processes: [],
      table_all_Processes_sub_process_by_processes: [],
      //*******************************
      table_all_Processes_by_sub_process: [],
      table_all_Processes_sub_process_by_sub_process: [],
      is_floor_select: false,
      is_group_select: false,
      is_process_select: false,
      is_sub_process_select: false,
      // todo: for Processes *******************************
      //*******************************
      //*******************************
      openModalsubLevelsCatForIdCard: false,
      subLevelsCat2_id: '',
      subLevelsCat3_id: '',
      subLevelsCat4_id: '',
      //*******************************
      //*******************************
      cloneAllModal: false,
      // --- متغیرهای جدید برای نقشه ---
      scale: 1,
      minScale: 0.1,
      initialScale: 1,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
      contentHeight: 400,
      mapCategories: [],
      isMapCollapsed: true,
      // --- متغیرهای جدید برای مرتب‌سازی ---
      sortableInstance: null,
    };
  },
  watch: {
    mapCategories: {
      handler() {
        this.calculateMapHeight();
      },
      deep: true
    }
  },
  methods: {
    // --- متدهای مرتب‌سازی ---
    initSortable() {
  this.$nextTick(() => {
    const tbody = document.querySelector('#sortable-table-body');
    if (tbody) {
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
      }
      this.sortableInstance = Sortable.create(tbody, {
        animation: 150,
        filter: '.not-draggable', // فقط ردیف‌هایی که کلاس not-draggable دارند غیرقابل جابجایی هستند
        preventOnFilter: false, // اجازه کلیک و تعامل روی ردیف‌های فیلتر شده
        // خط handle: '.drag-handle' را حذف کردیم تا کل ردیف قابل درگ شود
        ghostClass: 'sortable-ghost',
        onEnd: (evt) => {
          this.handleSortEnd(evt);
        }
      });
    }
  });
},
    handleSortEnd(evt) {
      const { oldIndex, newIndex } = evt;
      if (oldIndex === newIndex) return;
      // 1. آپدیت آرایه لوکال
      const movedItem = this.allProcesses.splice(oldIndex, 1)[0];
      this.allProcesses.splice(newIndex, 0, movedItem);
      // 2. ارسال به سرور
      this.saveNewOrder(movedItem.id, newIndex);
    },
    saveNewOrder(itemId, newIndex) {
      const formData = new FormData();
      formData.append('id', itemId);
      formData.append('new_order', newIndex + 1);
      fetch(`${this.base_url}/processes/update_order`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
        },
        body: formData
      })
      .then(response => response.json())
      .then(result => {
        if (result.error) {
          toast.error('خطا در ذخیره ترتیب');
          this.fetchAllProcesses();
        } else {
          toast.success('ترتیب با موفقیت تغییر کرد');
          this.fetchAllProcesses();
        }
      })
      .catch(err => {
        console.error(err);
        toast.error('خطا در ارتباط با سرور');
        this.fetchAllProcesses();
      });
    },
    // --- پایان متدهای مرتب‌سازی ---
    toggleMap() {
      this.isMapCollapsed = !this.isMapCollapsed;
      if (!this.isMapCollapsed) {
        this.$nextTick(() => {
          this.calculateMapHeight();
          this.fitMapToScreen();
        });
      }
    },
    calculateMapHeight() {
    if (this.isMapCollapsed) return;
    const canvas = this.$refs.canvasRef;
    if (canvas) {
      if (this.realMapHeight === 365) {
        const actualHeight = canvas.scrollHeight;
        this.realMapHeight = actualHeight + 30;
      }
      this.contentHeight = this.realMapHeight;
      this.$nextTick(() => {
        this.fitMapToScreen();
      });
    }
  },
  resetView() {
  if (this.isMapCollapsed) return;
  this.fitMapToScreen();
},
   fitMapToScreen() {
  setTimeout(() => {
    this.$nextTick(() => {
      const viewport = this.$refs.viewportRef;
      const canvas = this.$refs.canvasRef;
      if (!viewport || !canvas) return;
      const containerWidth = viewport.clientWidth;
      const containerHeight = viewport.clientHeight;
      const mapWidth = 1000;
      const padding = 40;
      const scaleX = (containerWidth - padding) / mapWidth;
      const currentMapHeight = canvas.scrollHeight || 500;
      const scaleY = (containerHeight - padding) / currentMapHeight;
      let newScale = Math.min(scaleX, scaleY);
      if (newScale > 1) newScale = 1;
      if (newScale < 0.1) newScale = 0.1;
      this.minScale = newScale;
      if (this.initialScale === 1) {
        this.initialScale = newScale;
      }
      this.scale = newScale;
      this.$nextTick(() => {
        const finalMapHeight = canvas.scrollHeight;
        this.translateX = (containerWidth - (mapWidth * this.scale)) / 2;
        this.translateY = (containerHeight - (finalMapHeight * this.scale)) / 2;
      });
    });
  }, 50);
},
    zoomIn() {
      this.scale *= 1.2;
    },
    zoomOut() {
      if (this.scale > this.minScale) {
        this.scale /= 1.2;
      }
    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX - this.translateX;
      this.startY = e.clientY - this.translateY;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      this.translateX = e.clientX - this.startX;
      this.translateY = e.clientY - this.startY;
    },
    stopDrag() {
      this.isDragging = false;
    },
   async downloadMap() {
  if (typeof html2canvas !== 'undefined') {
    const canvasEl = this.$refs.canvasRef;
    if (!canvasEl) return;
    try {
      const tempContainer = document.createElement('div');
      tempContainer.style.width = '1000px';
      tempContainer.style.height = this.contentHeight + 'px';
      tempContainer.style.background = '#ffffff';
      tempContainer.style.position = 'absolute';
      tempContainer.style.top = '-9999px';
      tempContainer.style.left = '-9999px';
      tempContainer.style.overflow = 'hidden';
      tempContainer.style.zIndex = '-1';
      const clonedContent = canvasEl.cloneNode(true);
      clonedContent.style.transform = 'none';
      clonedContent.style.position = 'static';
      clonedContent.style.overflow = 'visible';
      clonedContent.style.width = '1000px';
      clonedContent.style.height = this.contentHeight + 'px';
      tempContainer.appendChild(clonedContent);
      document.body.appendChild(tempContainer);
      const sideArrows = clonedContent.querySelectorAll('.side-arrow');
      sideArrows.forEach(arrow => {
        arrow.style.position = 'absolute';
        arrow.style.top = '0';
        arrow.style.bottom = '0';
        arrow.style.width = '55px';
        arrow.style.background = 'transparent';
        arrow.style.color = 'white';
        arrow.style.display = 'flex';
        arrow.style.alignItems = 'center';
        arrow.style.justifyContent = 'center';
        arrow.style.fontWeight = 'bold';
        arrow.style.fontSize = '12px';
        arrow.style.zIndex = '5';
        const svg = arrow.querySelector('svg');
        if (svg) {
            svg.style.position = 'absolute';
            svg.style.top = '0';
            svg.style.left = '0';
            svg.style.width = '100%';
            svg.style.height = '100%';
            const path = svg.querySelector('path');
            if(path) path.setAttribute('fill', '#2d3478');
        }
      });
      const arrowTexts = clonedContent.querySelectorAll('.arrow-text');
      arrowTexts.forEach(text => {
        text.style.writingMode = 'horizontal-tb';
        text.style.transform = 'rotate(-90deg)';
        text.style.whiteSpace = 'nowrap';
        text.style.display = 'flex';
        text.style.justifyContent = 'center';
        text.style.alignItems = 'center';
        text.style.width = '100%';
        text.style.height = '100%';
        text.style.fontSize = '12px';
        text.style.lineHeight = '1.5';
        text.style.zIndex = '6';
      });
      const allElements = clonedContent.querySelectorAll('*');
      allElements.forEach(el => {
        const originalEl = canvasEl.querySelector(`[data-v-id="${el.getAttribute('data-v-id')}"]`) || el;
        if (el.classList.contains('cat-header')) {
          el.style.direction = 'rtl';
          el.style.display = 'flex';
          el.style.justifyContent = 'space-between';
        }
        if (el.classList.contains('cat-content')) {
          el.style.direction = 'rtl';
          el.style.display = 'grid';
          el.style.gridTemplateColumns = 'repeat(4, 1fr)';
          el.style.gap = '5px';
        }
        if (el.classList.contains('class-box')) {
          el.style.direction = 'rtl';
          el.style.border = 'solid 1px #2d3478';
        }
        if (el.classList.contains('group-box')) {
          el.style.direction = 'rtl';
          el.style.border = '1px solid #5c5eb7';
        }
        if (el.classList.contains('process-box')) {
          el.style.direction = 'rtl';
          if (!el.style.backgroundColor || el.style.backgroundColor === 'transparent') {
             el.style.backgroundColor = '#d9f0ff';
          }
        }
      });
      await new Promise(resolve => setTimeout(resolve, 500));
      const canvas = await html2canvas(tempContainer, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        logging: false,
        width: 1000,
        height: this.contentHeight,
        allowTaint: true,
        removeContainer: true
      });
      document.body.removeChild(tempContainer);
      const link = document.createElement('a');
      link.download = 'process-map.png';
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (error) {
      console.error("Error downloading map:", error);
      alert("خطا در دانلود نقشه");
    }
  } else {
    alert("کتابخانه html2canvas یافت نشد");
  }
},
    prepareMapData() {
      const mappedCategories = [];
      let totalHeight = 60;
      if (this.table_all_Processes && this.table_all_Processes.length > 0) {
        this.table_all_Processes.forEach(mainItem => {
          const opCategory = {
            id: mainItem.id,
            titleEn: mainItem.title_en || "OPERATING PROCESS",
            titleFa: mainItem.title || "فرآیندهای اصلی",
            classes: []
          };
          let floorsList = [];
          if (Array.isArray(mainItem.floors)) {
            floorsList = mainItem.floors;
          } else if (typeof mainItem.floors === 'object' && mainItem.floors !== null) {
            floorsList = Object.values(mainItem.floors);
          }
          if (floorsList.length > 0) {
            totalHeight += 50;
            floorsList.forEach(floor => {
              const opClass = {
                id: floor.id,
                title: floor.title,
                groups: []
              };
              let groupsList = [];
              if (Array.isArray(floor.groups)) {
                groupsList = floor.groups;
              } else if (typeof floor.groups === 'object' && floor.groups !== null) {
                groupsList = Object.values(floor.groups);
              }
              let classHeight = 0;
              if (groupsList.length > 0) {
                groupsList.forEach(group => {
                  const opGroup = {
                    id: group.id,
                    title: group.title,
                    processes: []
                  };
                  let processList = [];
                  if (Array.isArray(group.processes)) {
                    processList = group.processes;
                  } else if (typeof group.processes === 'object' && group.processes !== null) {
                    processList = Object.values(group.processes);
                  }
                  let groupHeight = 25;
                  if (processList.length > 0) {
                    processList.forEach(proc => {
                      opGroup.processes.push({
                        id: proc.id,
                        title: proc.title,
                        color: "#d9f0ff"
                      });
                      groupHeight += 25;
                    });
                  }
                  groupHeight += 10;
                  opGroup.height = groupHeight;
                  classHeight += groupHeight;
                  opClass.groups.push(opGroup);
                });
              }
              classHeight += 40;
              totalHeight += classHeight;
              opCategory.classes.push(opClass);
            });
          }
          mappedCategories.push(opCategory);
        });
      }
      this.contentHeight = totalHeight + 20;
      if (this.contentHeight < 365) {
        this.contentHeight = 365;
      }
      this.mapCategories = mappedCategories;
      this.$nextTick(() => {
        this.fitMapToScreen();
      });
    },
    resultShow(type,is_floor,is_group,is_process,is_sub_process){
      if (!type){
        type=0
      }
      if (type===4){
        return  false
      }else if(type===0){
        return  true
      }
      else if (type===1){
        if (is_group){
          return true
        }
        return false
      } else if (type===2){
        if (is_process){
          return true
        }
        return false
      } else if (type===3){
        if (is_sub_process){
          return true
        }
        return false
      }
    },
    submitCloneAll(){
      fetch(`${this.base_url}/processes/store_by_mother`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message){
              this.cloneAllModal = false
              toast.success(response.message)
            }
          }).catch((err) => {
      })
    },
    cloneAll(){
      this.cloneAllModal = true
    },
    stylechange(id) {
      this.table_all_Processes_floor.forEach((ele) => {
        if (id === ele.parent_id) {
          return 'width: 32vw !important;';
        }
      })
    },
    showIdCard(is_group, is_pro, is_subPro, type) {
      let typeNumber = parseInt(type)
      if (is_group && typeNumber === 2) {
        return true
      } else if (is_pro && typeNumber === 3) {
        return true
      } else if (is_subPro && typeNumber === 4) {
        return true
      }
      return false
    },
    addNewIdCard() {
      this.openModalsubLevelsCatForIdCard = true
    }, addNewSelectedSub() {
      this.openModalsubLevelsCat = true
    },
    printMethod() {
    },
    editMethod(id) {
      this.edit(id)
      this.ProcessesId = id
      this.editModal = true
    },
    nextTree(id) {
      fetch(`${this.base_url}/processes/change_tree/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              this.Error = true
              this.ErrorM = response.error
              return
            }
            this.fetchAllProcesses()
          }).catch((err) => {
        console.log(err)
      })
    },
    previousTree(id) {
      fetch(`${this.base_url}/processes/change_tree/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: {
          'type': 'previous'
        }
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              this.Error = true
              this.ErrorM = response.error
              return
            }
            this.fetchAllProcesses()
          }).catch((err) => {
      })
    },
    setcolor(level) {
      if (level === 0) {
        return `background: rgb(77 187 255) !important`
      }
      if (level === 1) {
        return 'background: rgb(126 206 255) !important'
      }
      if (level === 2) {
        return 'background: rgb(170 223 255) !important'
      }
      if (level === 3) {
        return 'background: rgb(203 234 253) !important'
      }
       else {
        return 'background: #ffffff !important'
      }
    },
    addParentProcessesMethod(id, type) {
      this.ProcessesId = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.itemProcesses = result.item
            if (result.item.is_floor && !result.item.type) {
              this.levelSub_processes = 1
            } else if (result.item.is_group && result.item.type == 1) {
              this.levelSub_processes = 2
            } else if (result.item.is_sub_process && result.item.type == 2) {
              this.levelSub_processes = 3
            } else if (result.item.is_process && result.item.type == 3) {
              this.levelSub_processes = 4
            }
            this.title_for_edit_fa = result.item.title
            this.title_for_edit_en = result.item.title_en
            this.levelSub = result.item.type
          })
          .catch();
      if (type == null) {
        this.is_floor_select = true
        this.is_group_select = false
        this.is_process_select = false
        this.is_sub_process_select = false
      }
      if (type == 1) {
        this.is_floor_select = false
        this.is_group_select = true
        this.is_process_select = false
        this.is_sub_process_select = false
      }
      if (type == 2) {
        this.is_floor_select = false
        this.is_group_select = false
        this.is_process_select = true
        this.is_sub_process_select = false
      }
      if (type == 3) {
        this.is_floor_select = false
        this.is_group_select = false
        this.is_process_select = false
        this.is_sub_process_select = true
      }
      if (type == 4) {
        this.is_floor_select = false
        this.is_group_select = false
        this.is_process_select = false
        this.is_sub_process_select = false
      }
      this.addParentProcesses = true
      this.itemProcesses.length = 0
      this.title_for_edit_fa = ''
      this.levelSub = ''
      this.title_for_edit_en = ''
      this.ProcessesId = id
      this.title_for_edit_fa_processes = ''
      this.title_for_edit_en_processes = ''
      this.levelSub_processes = ''
      this.is_service = false;
    },
    SubmitParent() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title_for_edit_fa_processes);
      formdata.append('title_en', this.title_for_edit_en_processes);
      formdata.append('levelSub', this.levelSub_processes);
      formdata.append('is_service', this.is_service ? '1' : '0');
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/store_parent/${this.ProcessesId}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.categories.length = 0
            this.fetchAllProcesses()
            this.addParentProcesses = !this.addParentProcesses
            this.is_service = false;
          })
          .catch();
    },
    deleteItemModal(id) {
      this.ProcessesId = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.allProcesses.length = 0
            this.fetchAllProcesses()
             this.prepareMapData();
        this.resetView();
            this.deleteModal = false
          })
          .catch();
    },
    fetchAllProcesses() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      // دریافت لیست اصلی فرآیندها (اصلاح شده به /processes/all)
      fetch(`${this.base_url}/processes/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.items && result.items.length) {
              this.allProcesses = result.items;
            } else {
                this.allProcesses = [];
            }
          })
          .catch(err => {
            console.error("Error fetching all:", err);
          });
      fetch(`${this.base_url}/processes/all_table`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.items.length) {
              this.table_all_Processes.length = 0
              this.table_all_Processes_groups.length = 0
              this.table_all_Processes_process.length = 0
              this.table_all_Processes_floor.length = 0
              this.table_all_Processes_sub_process.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes.push(ele)
              })
            }
          })
          .catch(err => console.error(err));
      fetch(`${this.base_url}/processes/all_table_by_group`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.items.length) {
              this.table_all_Processes_by_group.length = 0
              this.table_all_Processes_groups_by_group.length = 0
              this.table_all_Processes_process_by_group.length = 0
              this.table_all_Processes_sub_process_by_group.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_group.push(ele)
              })
            }
          })
          .catch(err => console.error(err));
      fetch(`${this.base_url}/processes/all_table_by_process`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.items.length) {
              this.table_all_Processes_by_processes.length = 0
              this.table_all_Processes_process_by_processes.length = 0
              this.table_all_Processes_sub_process_by_processes.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_processes.push(ele)
              })
              result.process.forEach((ele) => {
                this.table_all_Processes_process_by_processes.push(ele)
              })
              result.sub_process.forEach((ele) => {
                this.table_all_Processes_sub_process_by_processes.push(ele)
              })
            }
          })
          .catch(err => console.error(err));
      fetch(`${this.base_url}/processes/all_table_by_sub_process`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.items.length) {
              this.table_all_Processes_by_sub_process.length = 0
              this.table_all_Processes_sub_process_by_sub_process.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_sub_process.push(ele)
              })
              result.sub_process.forEach((ele) => {
                this.table_all_Processes_sub_process_by_sub_process.push(ele)
              })
            }
          })
          .catch(err => console.error(err));
      Promise.all([
        fetch(`${this.base_url}/processes/all_table`, requestOptions).then(r => r.json()),
        fetch(`${this.base_url}/processes/all_table_by_group`, requestOptions).then(r => r.json()),
        fetch(`${this.base_url}/processes/all_table_by_process`, requestOptions).then(r => r.json()),
        fetch(`${this.base_url}/processes/all_table_by_sub_process`, requestOptions).then(r => r.json())
      ]).then(() => {
         this.prepareMapData();
         this.$nextTick(() => {
            this.updateContentHeight();
            this.fitMapToScreen();
            this.initSortable();
         });
      });
    },
    editTitleFa(id) {
      this.title_for_edit_fa = ''
      this.ProcessesId = id
      this.modalTitleFa = true
    },
    updateTitles(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.title_for_edit_fa.length) {
        formdata.append('title', this.title_for_edit_fa)
      }
      if (this.title_for_edit_en.length) {
        formdata.append('title_en', this.title_for_edit_en)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.modalTitleFa = false
            this.modalTitleEn = false
            this.title_for_edit_fa = ''
            this.title_for_edit_en = ''
            this.fetchAllProcesses()
          })
          .catch();
    },
    updateForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title_for_edit_fa)
      formdata.append('title_en', this.title_for_edit_en)
      formdata.append('type', this.levelSub)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/update_parent/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.editModal = false
            this.title_for_edit_fa = ''
            this.title_for_edit_en = ''
            this.fetchAllProcesses()
          })
          .catch();
    },
    editTitleEn(id) {
      this.ProcessesId = id
      this.title_for_edit_en = ''
      this.modalTitleEn = true
    },
    edit(id) {
      this.ProcessesId = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.itemProcesses = result.item
            if (result.item.is_floor && !result.item.type) {
              this.levelSub_processes = 1
            } else if (result.item.is_group && result.item.type == 1) {
              this.levelSub_processes = 2
            } else if (result.item.is_sub_process && result.item.type == 2) {
              this.levelSub_processes = 3
            } else if (result.item.is_process && result.item.type == 3) {
              this.levelSub_processes = 4
            }
            this.title_for_edit_fa = result.item.title
            this.title_for_edit_en = result.item.title_en
            this.levelSub = result.item.type
          })
          .catch();
    },
    SubmitSubCategories() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('categories', JSON.stringify(this.categories));
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/store`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.categories.length = 0
            this.fetchAllProcesses()
          })
          .catch();
    },
    addCategory() {
      if (this.loader){
        return;
      }
      this.loader = true
      if (!this.nameCat.length) {
        this.ErrorM = 'عنوان دسته اجباری است'
        toast.error(this.ErrorM)
        this.loader = false
        return
      }  else if (!this.encodingMethodCat.length) {
        this.ErrorM = 'نحوه کدگذاری طبقه اجباری است'
        toast.error(this.ErrorM)
        this.loader = false
        toast.error(this.ErrorM)
        return
      } else if (!this.subLevelsCat1 && !this.subLevelsCat2 && !this.subLevelsCat3 && !this.subLevelsCat4) {
        this.ErrorM = 'حداقل یک عناوین سطوح زیر مجموعه انتخاب کنید'
        toast.error(this.ErrorM)
        this.loader = false
        return
      }
      this.categories.push({
        name: this.nameCat,
        title_en: this.title_en,
        shortName: this.shortNameCat,
        encodingMethod: this.encodingMethodCat,
        subLevelsCat1: this.subLevelsCat1,
        subLevelsCat2: this.subLevelsCat2,
        subLevelsCat3: this.subLevelsCat3,
        subLevelsCat4: this.subLevelsCat4,
        isValueChain: this.isValueChainCat,
        subLevelsCat2_id: this.subLevelsCat2_id,
        subLevelsCat3_id: this.subLevelsCat3_id,
        subLevelsCat4_id: this.subLevelsCat4_id,
      });
      this.SubmitSubCategories()
      this.nameCat = ''
      this.shortNameCat = ''
      this.encodingMethodCat = ''
      this.subLevelsCat1 = ''
      this.subLevelsCat2 = ''
      this.subLevelsCat3 = ''
      this.subLevelsCat4 = ''
      this.isValueChainCat = ''
      this.subLevelsCat2_id = ''
      this.subLevelsCat3_id = ''
      this.subLevelsCat4_id = ''
      this.title_en = ''
      this.level_cardid = ''
      this.loader = false
    },
    removeCategory(index) {
      this.categories.splice(index, 1);
    },
    showSelectedSubCatMethod(id, subLevelsCat1, subLevelsCat2, subLevelsCat3, subLevelsCat4) {
      this.subLevelsCat1 = subLevelsCat1
      this.subLevelsCat2 = subLevelsCat2
      this.subLevelsCat3 = subLevelsCat3
      this.subLevelsCat4 = subLevelsCat4
      this.openModalsubLevelsCat = true
      this.sub_id = id
    },
    showSelectedSubCatIdCardMethod(subLevelsCat1, subLevelsCat2, subLevelsCat3) {
      this.subLevelsCat2 = subLevelsCat1
      this.subLevelsCat3 = subLevelsCat2
      this.subLevelsCat4 = subLevelsCat3
      this.subLevelsCat2_id = subLevelsCat1
      this.subLevelsCat3_id = subLevelsCat2
      this.subLevelsCat4_id = subLevelsCat3
      this.openModalsubLevelsCatForIdCard = true
    },
    removeModalSelectedSub() {
      this.openModalsubLevelsCat = false
      this.categories.forEach((element, index) => {
        if (index === this.sub_id) {
          element.subLevelsCat1 = this.subLevelsCat1;
          element.subLevelsCat2 = this.subLevelsCat2;
          element.subLevelsCat3 = this.subLevelsCat3;
          element.subLevelsCat4 = this.subLevelsCat4;
        }
      })
      this.sub_id = 0
    },
    checkIsMother(){
      if (!this.is_mother){
        router.push('/pishkhan')
      }
    }
  },
  mounted() {
    this.fetchAllProcesses()
    this.checkIsMother()
    this.$nextTick(() => {
       if (this.$refs.canvasRef) {
         new ResizeObserver(() => { this.fitMapToScreen() }).observe(this.$refs.canvasRef);
       }
       this.initSortable();
    });
  },
  computed: {
    nameCatHeight() {
      return this.nameCat ? `${this.nameCat.length*2}px` : 'auto';
    },
    title_enHeight() {
      return this.title_en ? `${this.title_en.length*2}px` : 'auto';
    },
    filteredItems() {
      return this.allProcesses.filter(item => {
        if (this.searchProcesses) {
          const titleIncludes = item['title'] && item['title'].includes(this.searchProcesses);
          // اصلاح شده: بررسی وجود مقدار قبل از استفاده از includes
          const categoryIncludes = item['category'] && item['category'].includes(this.searchProcesses);
          const codeIncludes = item['code'] && item['code'].includes(this.searchProcesses);
          
          return titleIncludes || categoryIncludes || codeIncludes;
        } else {
          return true;
        }
      });
    },
  }
}
</script>
<style scoped>
.row {
  padding: .5vw;
}
@media print {
  .no-print, .hide {
    display: none;
  }
}
.map-viewport {
  position: relative;
  overflow: hidden;
  cursor: grab;
  background: #f0f0f0;
  height: 500px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
}
.map-canvas {
  width: 1000px;
  position: relative;
  transform-origin: 0 0;
  background: white;
  box-sizing: border-box;
  overflow: visible;
   transform-origin: 0 0 !important;
  min-height: 365px !important;
  height: auto;
  padding: 30px 0px;
}
.side-arrow {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 55px;
  background: transparent;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  z-index: 5;
}
.arrow-text {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  z-index: 6;
  font-size: 12px;
  text-align: center;
  line-height: 1.5;
}
.right {
  right: 0;
}
.left {
  left: 0;
}
.categories-wrapper {
  display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0px 60px 20px 60px;
    width: 881px;
    justify-content: space-between;
    align-items: center
}
.category-box {
  width: 100%;
  border: 2px solid #2d3478;
  border-radius: 8px;
  background: white;
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: hidden;
}
.cat-header {
  background: linear-gradient(90deg, #ff9800, #ff5722);
  color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  direction: ltr;
}
.cat-title-en {
  font-size: 11px;
  font-weight: bold;
  margin-top: -3px;
}
.cat-title-fa {
  font-size: 11px;
  font-weight: bold;
  margin-top: -3px;
}
.cat-content {
  padding: 5px;
  background: #f9f9f9;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  align-content: start;
}
.class-box {
  background: #ffffff;
  border: solid 1px #2d3478;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}
.class-title {
  background: #2d3478;
  color: white;
  padding: 5px 2px;
  border-radius: 3px;
  text-align: center;
  font-size: 9px;
  margin-bottom: 2px;
  white-space: normal;
  line-height: 21px;
}
.group-box {
  background: white;
  padding: 2px;
  border-radius: 2px;
  border: 1px solid #5c5eb7;
  margin: 5px 0px;
}
.group-title {
  background: #5c5eb7;
  padding: 5px 2px;
  border-radius: 2px;
  text-align: center;
  font-size: 8px;
  font-weight: bold;
  margin-bottom: 2px;
  white-space: normal;
  line-height: 17px;
  color: white;
}
.process-box {
  padding: 5px 4px;
  border-radius: 2px;
  margin: 4px 0px;
  font-size: 8px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 17px;
}
.no-data-message {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #666;
  font-size: 1.2rem;
  font-weight: bold;
}
.btn-zoom-custom {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  line-height: 1;
}
.btn-zoom-custom:disabled {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.3);
  cursor: not-allowed;
  opacity: 0.5;
}
.btn-zoom-custom:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
}
.btn-zoom-custom:active:not(:disabled) {
  transform: translateY(1px);
}
.btn-action-custom {
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  line-height: 1;
}
.btn-action-custom:disabled {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.3);
  cursor: not-allowed;
  opacity: 0.5;
}
.btn-action-custom:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
}
.accordion-icon {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 14px;
}
.map-header {
  user-select: none;
}
/* استایل‌های جدید برای Sortable */
.sortable-ghost {
  opacity: 0.4;
  background-color: #f4f4f4;
  border: 2px dashed #999;
}
.sortable-drag {
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  cursor: grabbing;
}
/* استایل آیکون دست */
.drag-handle {
  cursor: grab;
  margin-left: 5px;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 4px;
  transition: background 0.2s;
}
.drag-handle:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
/* استایل برای ردیف‌های غیرقابل جابجایی (طبقه، گروه و ...) */
tr.not-draggable {
  cursor: default !important;
}
/* استایل برای ردیف‌های قابل جابجایی (فرآیند) */
tr:not(.not-draggable) {
  cursor: move; /* نشانگر جابجایی */
}
</style>